import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Divider, FormControl, InputLabel, Select, Typography } from "@mui/material";
import { useState } from "react";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext.ts";
import type { ReportGroup } from "../../../../../../api/types/svTypes.ts";
import AddGroupDialog from "../../groups/actions/AddGroupDialog.tsx";

interface Props {
  clientCode: string;
  value: string;
  groups?: ReportGroup[];
  disabled?: boolean;
  canCreateGroup?: boolean;
  onChange: (groupId: string) => void;
}

export default function ReportGroupSelect({ clientCode, value, groups, disabled, canCreateGroup, onChange }: Props) {
  const { sendNotification } = useNotificationContext();

  const [showAddGroup, setShowAddGroup] = useState(false);
  const [createdGroup, setCreatedGroup] = useState<ReportGroup>();

  const options =
    createdGroup && !groups?.some((g) => g.id === createdGroup.id) ? [...(groups || []), createdGroup] : groups;

  return (
    <>
      <FormControl fullWidth disabled={disabled}>
        <InputLabel>Group</InputLabel>
        <Select
          value={value}
          label="Group"
          MenuProps={{ slotProps: { paper: { sx: { maxWidth: 392 } } } }}
          onChange={(evt) => {
            if (evt.target.value != null) {
              onChange(evt.target.value);
            }
          }}
        >
          {options?.map((group) => (
            <MenuItemStyled key={group.id} value={group.id}>
              <Typography noWrap>{group.caption}</Typography>
            </MenuItemStyled>
          ))}
          {canCreateGroup && [
            options && options.length > 0 && <Divider key="new-group-divider" />,
            <MenuItemStyled key="new-group" sx={{ gap: 1 }} onClick={() => setShowAddGroup(true)}>
              <AddRoundedIcon color="primary" />
              <Typography color="primary">New Group</Typography>
            </MenuItemStyled>,
          ]}
        </Select>
      </FormControl>
      {showAddGroup && (
        <AddGroupDialog
          clientCode={clientCode}
          onAdded={(group) => {
            setCreatedGroup(group);
            onChange(group.id);
            sendNotification("The group was successfully created.");
          }}
          onClose={() => setShowAddGroup(false)}
        />
      )}
    </>
  );
}
